window.addEventListener('load', function () {
	var searchField = document.getElementById('zip');
	var allMarkers = $('.marker');
	var homeCare = $('.marker.home-care');
	var homeHealth = $('.marker.home-health');
	var combined = $('.marker.home-health.home-care');

	var locationType = '';
	var locationComponents = [];
	var locationlist = [];
    
    const states = {
        "alabama": "al",
        "alaska": "ak",
        "arizona": "az",
        "arkansas": "ar",
        "california": "ca",
        "colorado": "co",
        "connecticut": "ct",
        "delaware": "de",
        "florida": "fl",
        "georgia": "ga",
        "hawaii": "hi",
        "idaho": "id",
        "illinois": "il",
        "indiana": "in",
        "iowa": "ia",
        "kansas": "ks",
        "kentucky": "ky",
        "louisiana": "la",
        "maine": "me",
        "maryland": "md",
        "massachusetts": "ma",
        "michigan": "mi",
        "minnesota": "mn",
        "mississippi": "ms",
        "missouri": "mo",
        "montana": "mt",
        "nebraska": "ne",
        "nevada": "nv",
        "new-hampshire": "nh",
        "new-jersey": "nj",
        "new-mexico": "nm",
        "new-york": "ny",
        "north-carolina": "nc",
        "north-dakota": "nd",
        "ohio": "oh",
        "oklahoma": "ok",
        "oregon": "or",
        "pennsylvania": "pa",
        "rhode-island": "ri",
        "south-carolina": "sc",
        "south-dakota": "sd",
        "tennessee": "tn",
        "texas": "tx",
        "utah": "ut",
        "vermont": "vt",
        "virginia": "va",
        "washington": "wa",
        "west-virginia": "wv",
        "wisconsin": "wi",
        "wyoming": "wy"
    };

	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	function initMap($el) {
		// Set markers based on service checkboxes
		if (!$('#home-care').is(':checked') && !$('#home-health').is(':checked')) { // If none checked
			var $markers = allMarkers;
		} else if ($('#home-care').is(':checked') && !$('#home-health').is(':checked')) { // If Home Care is checked
			var $markers = homeCare;
		} else if ($('#home-health').is(':checked') && !$('#home-care').is(':checked')) { // If Home Health if checked
			var $markers = homeHealth;
		} else { // If both are checked
			var $markers = combined;
		}
		// Create generic map.
		var mapArgs = {
			zoom: $el.data('zoom') || 16,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		};
		var map = new google.maps.Map($el[0], mapArgs);

		// Add markers.
		map.markers = [];
		var searchValue = searchField.value.toString();

		$markers.each(function () {
			initMarker($(this), map, searchValue);
		});


		// If there's a search parameter, center map on the matches
		if (searchValue.length > 0) {
			if (locationlist.length > 0) {
				updateListNew(locationlist)
				centerMap(map);
				locationlist = [];
			} else {
				$markers.each(function () {
					initMarker($(this), map, '');
				});
				var address = searchValue;
				var lat, lng, myLatlng;
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode( { 'address': address, 'componentRestrictions': {'country':'US'} }, function(results) {
					lat = parseFloat(results[0].geometry.location.lat());
					lng = parseFloat(results[0].geometry.location.lng());
	
					myLatlng = new google.maps.LatLng(lat, lng);
					map.setCenter(myLatlng);
					locationType = results[0].types[0];
					locationComponents = results[0]["address_components"];
	
					// If searching by state, zoom further out
					if ( locationType == "administrative_area_level_1" ) {
						map.setZoom(7);
					} else {
						map.setZoom(10);
					}
				});
				setTimeout( function() {
					updateList(locationComponents, locationType);
				}, 500);
			}

		} else {
			$('.location-list__item').show()
			centerMap(map);

		}

		// Wait for response, then perform text list filtering
		// TODO: Do this with a promise/async/await


		// Return map instance.
		return map;
	}

	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	function initMarker($marker, map, searchValue) {
		var lat = $marker.data('lat');
		var lng = $marker.data('lng');
		var city = $marker.data('city');
		var state = $marker.data('state');
		var zip = $marker.data('zip');
		var latLng = {
			lat: parseFloat(lat),
			lng: parseFloat(lng)
		};
		if (searchValue == '') {
			var marker = new google.maps.Marker({
				position: latLng,
				map: map,
			});

			// Append to reference for later use.
			map.markers.push(marker);

			// If marker contains HTML, add it to an infoWindow.
			if ($marker.html()) {

				// Create info window.
				var infowindow = new google.maps.InfoWindow({
					content: $marker.html()
				});

				// Show info window when marker is clicked.
				google.maps.event.addListener(marker, 'click', function () {
					infowindow.open(map, marker);
				});
			}
		} else {
			var q = (searchValue || '').toString().replace(/^\s+|\s+$/g, '').toLowerCase();
			var isStateAbbrev = (/^[a-z]{2}$/).test(q);

			var checkCity = false;
			var checkZip = false;
			var checkState = false;

			if (isStateAbbrev) {
				// Normalize marker state → always compare as abbreviation
				var markerStateName = (state || '').toString().toLowerCase(); // "illinois" OR "il"
				var markerStateAbbrev = states[markerStateName] || markerStateName; // -> "il"

				checkState = (markerStateAbbrev === q);
			} else {
				checkCity  = isMatch(city, searchValue);
				checkZip   = isMatch(zip, searchValue);
				checkState = isMatch(state, searchValue);
			}

			if (checkState || checkZip || checkCity) {
				var marker = new google.maps.Marker({
					position: latLng,
					map: map,
				});
				map.markers.push(marker);

				if ($marker.html()) {
					var infowindow = new google.maps.InfoWindow({
						content: $marker.html()
					});
					google.maps.event.addListener(marker, 'click', function () {
						infowindow.open(map, marker);
					});
				}

				locationlist.push(city + '-' + states[state.toLowerCase()]);
			}
		}
	}
	function isMatch(value, pattern) {
		const escapedPattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		const regex = new RegExp(escapedPattern.replace(/%/g, '.*').replace(/_/g, '.'), 'i');
		return regex.test(value);
	}

	function updateListNew(citiesStates) {
		const formattedCitiesStates = citiesStates.map(function(cityState) {
			return cityState.replace(/\s+/g, '-').toLowerCase();
		});

		$('.location-list__item').each(function () {
            const cityState = $(this).data('city') + '-' + $(this).data('state');
			const currentCityState = cityState.replace(/\s+/g, '-').toLowerCase();

			if (formattedCitiesStates.includes(currentCityState)) {
				$(this).show();
			} else {
				$(this).hide();
			}

			if ( currentCityState == 'warren' && $(this).data('state') == 'pa' && searchField.value.toString().toLowerCase().includes('michigan') ) {
				$(this).hide();
			}

			if ( currentCityState == 'warren' && $(this).data('state') == 'mi' && searchField.value.toString().toLowerCase().includes('pennsylvania') ) {
				$(this).hide();
			}
		});
	}

	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   object The map instance.
	 * @return  void
	 */
	function centerMap(map) {

		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function (marker) {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		// Case: Single marker.
		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());

			// Case: Multiple markers.
		} else {
			map.fitBounds(bounds);
		}
	}


	/**
	 * Get the value for a given key in address_components
	 * 
	 * @param {Array} components address_components returned from Google maps autocomplete
	 * @param type key for desired address component
	 * @returns {String} value, if found, for given type (key)
	 * 
	 * Found here: https://stackoverflow.com/questions/8313876/more-efficient-way-to-extract-address-component
	 */
	function extractFromAddress(components, type) {
		if (components) {
			return components.filter(function(component) {
				return component.types.indexOf(type) === 0;
			}).map(function(item) {
				return item.short_name;
			}).pop() || null;
		} else {
			return null;
		}
	}


	/**
	 * Hide/Show List items based on search parameters
	 * 
	 * Filtering is based on Home Care, and Home Health.
	 * These services are on a per-state, not per location basis. On 08/24/2021,
	 * all states offered Home Care, but only Indiana and Mississippi offer Home Health.
	 * That is handled as an ACF parameter on the state/region category, and echoed as
	 * a class on each marker. State, city, and zip code are also echoed as a class on each marker.
	 * 
	 * Upon search we will get the queried location type from the API hit and what Google
	 * actually search for (since it does some spell correction, etc.), and look for class-based
	 * matches, in addition to only including the "home care" or "home health" locations if those
	 * filters are selected as well.
	 */
	function updateList(components, locationType) {
		var checked = ''; // Concatenated values of filter checkboxes
		var dataName = ''; // Type of map search parameter
		var fullData = ''; // Full data attribute

		if (locationType == 'postal_code') {
			dataName = 'postal';
		} else if (locationType == 'locality') {
			dataName = 'city';
		} else {
			dataName = 'state';
		}

		var data = extractFromAddress(components, locationType);
		// Convert spaces to dashes and make lower case
		if (data) { data = data.replace(/\s+/g, '-').toLowerCase(); }

		// Concatenate data attribute
		fullData = 'data-' + dataName + '="' + data + '"';

		// Turn checkbox values into a string
		$('#checkboxes input:checked').each(function () {
			checked += '.' + $(this).val();
		});

		// Loop through list items, and if they match attributes and checkbox classes, show them
		$('.location-list__item').each(function () {
			// If there are no search parameters, show all list items
			if ($('#checkboxes input:checked').length == 0 && $('#zip').val() == '') {
				$('.location-list__item').show();
			} // If there is only a search field parameter, exclude checkbox classes
			else if ($('#checkboxes input:checked').length == 0 && $('#zip').val() != '') {
				if ($(this).is('.location-list__item[' + fullData + ']')) {
					$(this).show();
				} else {
					$(this).hide();
				}
			} // If there are only checkboxes and no search field, exclude data attribute filtering
			else if ($('#checkboxes input:checked').length > 0 && $('#zip').val() == '') {
				if ($(this).is('.location-list__item' + checked)) {
					$(this).show();
				} else {
					$(this).hide();
				}
			} // The full enchilada
			else {
				if ($(this).is('.location-list__item[' + fullData + ']' + checked)) {
					$(this).show();
				} else {
					$(this).hide();
				}
			}
		});
	}


	/**
	 * Run it all on page load
	 */
	$(document).ready(function () {
		$('#map').each(function () {
			// Render maps on page load.
			var map = initMap($(this));
		});

		// Prevent form from reloading page on submit, and re-generate map
		document.getElementById('location-finder__form').addEventListener('submit', function (e) {
			e.preventDefault();
			var map = initMap($('#map'));
		});

		/**
		 * Re-initialize map on search button click
		 */
		document.getElementById('location-submit').addEventListener('click', function () {
			var map = initMap($('#map'));
		});

		/**
		 * View All/Reset button
		 */
		$('#location-all').on('click', function () {
			$('#zip').val('');
			var map = initMap($('#map'));
			$('.location-list__item').show();
		});
	});
});